import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "view-form" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "infos" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "subtitle" }
const _hoisted_6 = {
  key: 0,
  class: "questions"
}
const _hoisted_7 = {
  key: 0,
  class: "title"
}
const _hoisted_8 = { class: "name" }
const _hoisted_9 = { class: "description" }
const _hoisted_10 = {
  key: 0,
  class: "question"
}
const _hoisted_11 = {
  key: 1,
  class: "question"
}
const _hoisted_12 = {
  key: 2,
  class: "question"
}
const _hoisted_13 = {
  key: 3,
  class: "question"
}
const _hoisted_14 = {
  key: 4,
  class: "question"
}
const _hoisted_15 = {
  key: 5,
  class: "question"
}
const _hoisted_16 = { class: "photo" }
const _hoisted_17 = { class: "header" }
const _hoisted_18 = { class: "label" }
const _hoisted_19 = {
  key: 0,
  class: "description"
}
const _hoisted_20 = { class: "content" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "actions" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]

import { computed, onMounted, ref, watch, watchEffect } from "vue";

import { useI18n } from "vue-i18n";
import { formatMetadata } from "@/common/utils/common";
import { toast } from "@/common/utils/toast";

// import { historyAnswerAdd } from "@/common/api/rest/history";

import {
  baseCamera,
  baseCheckbox,
  baseConfirm,
  baseInput,
  baseRadio,
  baseSelect,
  baseTextarea,
  baseTooltip,
  svgIcon,
} from "@/common/components";

import { fileAdd, fileGet, fileDel } from "@/common/api/rest/files";

import type { AnswersType, QuestionType } from "@/common/types/question";

interface PayloadType {
  [key: string]: any;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'questions',
  props: {
    accountId: {},
    ownerId: {},
    answersId: {},
    answers: {},
    questions: {},
    field: {},
    code: {},
    name: {},
    orders: {}
  },
  emits: ["update:data", "del"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const payload = ref<PayloadType>({});

const selectedIndex = ref<number | null>(null);
const images = ref<{ [key: string]: string }>({});

const showCamera = ref(false);
const showConfirmImageDel = ref(false);

function formatAnswers() {
  if (!props.questions || !props.answers?.metadata) return;

  try {
    const metadata = props.answers.metadata;

    if (metadata?.[props.field]?.[props.ownerId]) {
      Object.entries(metadata[props.field][props.ownerId])?.forEach(
        ([key, value]) => {
          if (value?.file_id) {
            if (value?.type === "image") {
              fileGet(value.file_id)
                .then((response) => {
                  const { success, data } = response;
                  console.log("data", data);
                  if (success) {
                    images.value[key] = `${data.infos},${data.base64}`;
                  }
                })
                .catch(() => {
                  toast({ message: t("error.default"), type: "error" });
                });
            }
          }
          payload.value[key] = value;
        },
      );
    }
  } catch (error) {
    console.log("error", error);
  }
}

function formatQuestions() {
  if (!props.questions) return;

  payload.value = (props.questions || [])
    ?.sort((a, b) => {
      if (!props.orders) return 0;

      const indexA = props.orders?.indexOf(a.question_id);
      const indexB = props.orders?.indexOf(b.question_id);

      return indexA - indexB;
    })
    ?.reduce((acc, item) => {
      if (item.type === "title") return acc;

      acc = {
        ...acc,
        [item.question_id]: null,
      };
      return acc;
    }, {});
}

function update() {
  const metadata = props.answers?.metadata ?? {};

  const formatted = {
    ...metadata,
    [props.field]: {
      ...metadata?.[props.field],
      [props.ownerId]: payload.value,
    },
  };

  emit("update:data", formatted);
}

// async function updateSingle(questionId: string) {
//   const fieldName = `metadata.${props.field}.${props.ownerId}.${questionId}`;
//   const value = payload.value[questionId];

//   await historyAnswerAdd(props.accountId, props.answersId, {
//     field_name: fieldName,
//     new_value: value,
//   });
// }

// async function updateMultiple(questionId: string) {
//   const fieldName = `metadata.${props.field}.${props.ownerId}.${questionId}`;
//   const value = JSON.stringify(payload.value[questionId]);

//   await historyAnswerAdd(props.accountId, props.answersId, {
//     field_name: fieldName,
//     new_value: value,
//   });
// }

function openCamera(index: number) {
  selectedIndex.value = index;
  showCamera.value = true;
}

function closeCamera() {
  selectedIndex.value = null;
  showCamera.value = false;
}

function uploadImage(image: string) {
  if (selectedIndex.value === null || !props.questions || !payload.value)
    return;

  const question = props.questions[selectedIndex.value];
  if (!question) return;

  showCamera.value = false;
  const fileId = `${props.ownerId}_${question.question_id}`;

  fileAdd(fileId, {
    name: question.name,
    infos: "data:image/png;base64",
    file: image.replace("data:image/png;base64,", ""),
    extension: "png",
    size: 100,
    type: "image",
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        payload.value[question.question_id] = data[0];
        update();
        // updateMultiple(question.question_id);

        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function delImage(index: number) {
  selectedIndex.value = index;
  showConfirmImageDel.value = true;
}

function delImageCancel() {
  selectedIndex.value = null;
  showConfirmImageDel.value = false;
}

function delImageConfirm() {
  if (selectedIndex.value === null || !props.questions || !payload.value)
    return;

  const question = props.questions[selectedIndex.value];
  if (!question) return;

  showConfirmImageDel.value = false;

  fileDel(payload.value[question.question_id].file_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        payload.value[question.question_id] = null;
        delImageCancel();
        update();
        // updateMultiple(question.question_id);
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

watch(
  () => props.answers,
  () => {
    formatAnswers();
  },
);

watch(
  () => props.questions,
  () => {
    formatQuestions();
    formatAnswers();
  },
);

onMounted(() => {
  formatQuestions();
  formatAnswers();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(props.code), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(props.name), 1)
      ])
    ]),
    (payload.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.questions, (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (item.type === 'TITLE')
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(item.name), 1),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(item.description), 1)
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (item.type === 'INPUT')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createVNode(_unref(baseInput), {
                            modelValue: payload.value[item.question_id],
                            "onUpdate:modelValue": ($event: any) => ((payload.value[item.question_id]) = $event),
                            value: payload.value[item.question_id],
                            required: item.required,
                            placeholder: item.placeholder,
                            onBlur: _cache[0] || (_cache[0] = ($event: any) => (update()))
                          }, {
                            label: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.name) + " " + _toDisplayString(item.required ? "*" : ""), 1)
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue", "value", "required", "placeholder"])
                        ]))
                      : _createCommentVNode("", true),
                    (item.type === 'TEXTAREA')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createVNode(_unref(baseTextarea), {
                            modelValue: payload.value[item.question_id],
                            "onUpdate:modelValue": ($event: any) => ((payload.value[item.question_id]) = $event),
                            value: payload.value[item.question_id],
                            required: item.required,
                            placeholder: item.placeholder,
                            onBlur: _cache[1] || (_cache[1] = ($event: any) => (update()))
                          }, {
                            label: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.name) + " " + _toDisplayString(item.required ? "*" : ""), 1)
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue", "value", "required", "placeholder"])
                        ]))
                      : (item.type === 'RADIO')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createVNode(_unref(baseRadio), {
                              modelValue: payload.value[item.question_id],
                              "onUpdate:modelValue": ($event: any) => ((payload.value[item.question_id]) = $event),
                              id: item.question_id,
                              value: payload.value[item.question_id]?.toString(),
                              options: item.metadata?.options || [],
                              required: item.required,
                              onChange: _cache[2] || (_cache[2] = ($event: any) => (update()))
                            }, {
                              label: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.name) + " " + _toDisplayString(item.required ? "*" : ""), 1)
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue", "id", "value", "options", "required"])
                          ]))
                        : (item.type === 'SELECT')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _createVNode(_unref(baseSelect), {
                                modelValue: payload.value[item.question_id],
                                "onUpdate:modelValue": ($event: any) => ((payload.value[item.question_id]) = $event),
                                id: item.question_id,
                                value: payload.value[item.question_id]?.toString(),
                                options: item.metadata?.options || [],
                                required: item.required,
                                onChange: _cache[3] || (_cache[3] = ($event: any) => (update()))
                              }, {
                                label: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.name) + " " + _toDisplayString(item.required ? "*" : ""), 1)
                                ]),
                                _: 2
                              }, 1032, ["modelValue", "onUpdate:modelValue", "id", "value", "options", "required"])
                            ]))
                          : (item.type === 'CHECKBOX')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createVNode(_unref(baseCheckbox), {
                                  modelValue: payload.value[item.question_id],
                                  "onUpdate:modelValue": ($event: any) => ((payload.value[item.question_id]) = $event),
                                  id: item.question_id,
                                  options: item.metadata?.options || [],
                                  value: payload.value[item.question_id],
                                  onChange: _cache[4] || (_cache[4] = ($event: any) => (update()))
                                }, {
                                  label: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.name) + " " + _toDisplayString(item.required ? "*" : ""), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "id", "options", "value"])
                              ]))
                            : (item.type === 'PHOTO')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                  _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("div", _hoisted_17, [
                                      _createElementVNode("div", _hoisted_18, _toDisplayString(item.name), 1),
                                      (item.description)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(item.description), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_20, [
                                      (payload.value[item.question_id]?.path)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createElementVNode("img", {
                                              src: images.value[item.question_id],
                                              alt: ""
                                            }, null, 8, _hoisted_21),
                                            _createElementVNode("div", _hoisted_22, [
                                              _createElementVNode("button", {
                                                type: "button",
                                                class: "btn btn-md btn-danger px-4",
                                                onClick: ($event: any) => (delImage(index))
                                              }, _toDisplayString(_unref(t)("common.labels.delete")), 9, _hoisted_23)
                                            ])
                                          ], 64))
                                        : (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            type: "button",
                                            class: "btn btn-md btn-default px-4",
                                            onClick: ($event: any) => (openCamera(index))
                                          }, _toDisplayString(_unref(t)("common.labels.capture")), 9, _hoisted_24))
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                  ], 64))
            ], 64))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (showCamera.value)
      ? (_openBlock(), _createBlock(_unref(baseCamera), {
          key: 1,
          onCapture: _cache[5] || (_cache[5] = ($event: any) => (uploadImage($event))),
          onClose: _cache[6] || (_cache[6] = ($event: any) => (closeCamera()))
        }))
      : _createCommentVNode("", true),
    _createVNode(_unref(baseConfirm), {
      "max-width": "600px",
      show: showConfirmImageDel.value,
      title: _unref(t)('common.modals.titles.remove_image').toUpperCase(),
      message: _unref(t)('common.modals.messages.remove_image'),
      onCancel: _cache[7] || (_cache[7] = ($event: any) => (delImageCancel())),
      onConfirm: _cache[8] || (_cache[8] = ($event: any) => (delImageConfirm()))
    }, null, 8, ["show", "title", "message"])
  ]))
}
}

})